import { Text } from 'react-native';
import styled from 'styled-components/native';

export const LabelWrapper = styled(Text)`
    min-width: 170px;
`;
